/**
 * Email validation shared by the link-generation forms.
 *
 * Kept deliberately simple and permissive: the goal is to catch typos such as a
 * missing "@" or domain, not to enforce RFC 5322. Anything stricter rejects
 * legitimate addresses.
 */

// Matches the pattern already used by PatientRegistrationPage.
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** True when the value is a single well-formed email address. */
export function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value ?? '').trim());
}

/**
 * Splits a comma-separated CC field into trimmed, non-empty addresses.
 * Semicolons are accepted too because they are what Outlook produces on paste.
 */
export function splitEmailList(value) {
  return String(value ?? '')
    .split(/[,;]/)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

/**
 * Validates a comma-separated list of addresses.
 * Returns every invalid entry so the message can name them, and treats an empty
 * value as valid — callers decide whether the field is required.
 */
export function findInvalidEmails(value) {
  return splitEmailList(value).filter((entry) => !isValidEmail(entry));
}
